<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="text-right pb-3" v-if="allowMarking">
      <button :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'" @click="allToDelivered" class="btn ml-2" type="button">
        Доставлено
      </button>
      <button :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" @click="allToPaid" class="btn ml-2" type="button">Оплачено</button>
      <button :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" @click="allToPassed" class="btn ml-2" type="button">Сдано</button>
    </div>
    <div class="text-right">
      <button @click.prevent="print2" class="btn btn-danger ml-2" v-if="isUndeliveredOrdersByDateAndTour">Печать недоставленных</button>
      <button @click.prevent="print" class="btn btn-warning ml-2" v-if="allowPrinting">Печать</button>
      <button @click="$router.go(-1)" class="btn btn-secondary ml-2" type="button">Назад</button>
    </div>
<!--    <undelivered-orders-by-date-and-tour :items="undeliveredOrdersByDateAndTour" id="printMe2" v-if="isUndeliveredOrdersByDateAndTour"></undelivered-orders-by-date-and-tour>-->
    <div class="mt-3" id="printMe">
      <div v-for="(receptionOrders) in orderListGroupByPoint" style="page-break-before: always!important;">
        <legend>Накладная</legend>
        <div class="pagebreak"></div>
        <table class="table table-sm table-borderless">
          <tbody>
          <tr>
            <td>
              Доставка: {{$route.query.time}}
            </td>
            <td>
              <vue-barcode :margin="0" :value="courierBarCode" :width="2" display-value="false" height="20">
                Ошибка штрихкода
              </vue-barcode>
            </td>
            <td>
              Курьер: {{courier.Mname}} {{courier.Lname}} {{courier.Fname}} ({{courier.Login}})
            </td>
            <td>
              {{currentDate}}
            </td>
          </tr>
          </tbody>
        </table>

        <table class="table table-bordered table-hover table-sm w-100 table-cell-align-middle">
          <thead>
          <tr class="">
            <th class="d-print-none">
              <input type="checkbox" v-model="checkAll">
            </th>
            <th>Объезд</th>
            <th>Пункт</th>
            <th style="width: 50px" class="text-right" v-for="paymentType in $root.paymentTypes">{{paymentType.Name}}</th>
            <th width="10"></th>
            <th class="d-print-none"></th>
            <th class="d-print-none">Дата оплаты</th>
            <th class="d-print-none">Дата получения</th>
          </tr>
          </thead>
          <tbody>

          <template>
            <template v-for="(order, index) in receptionOrders">
              <template v-if="index === 0">
                <tr class="font-weight-bold">
                  <td class="d-print-none" width="1">
                    <input :checked="fullFilledPoint(order.Point.Id)" @change="checkByPointId($event, order.Point.Id)" type="checkbox">
                  </td>
                  <td>{{order.Tour.Name}}</td>
                  <td :colspan="$root.paymentTypes.length + 1" width="70">
                    {{order.Point.Reception}}
                    <span class="badge badge-light font-weight-normal" style="font-size: 100%;">
                      Итого: <span>{{getReceptionSummary(receptionOrders)}}</span>
                    </span>
                    <span class="badge badge-warning font-weight-normal ml-1" style="font-size: 100%;" v-if="pointDebt[order.Point.Id]">
                      Долг: {{pointDebt[order.Point.Id]}}
                    </span>
                  </td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                  <td class="d-none d-print-table-cell" width="10">
                    <!--                  <vue-barcode :value="pointBarCode(order.Point)" :width="2" height="20" :margin="0" display-value="false">-->
                    <!--                    Ошибка штрихкода-->
                    <!--                  </vue-barcode>-->
                  </td>
                </tr>
              </template>
              <tr>
                <td class="d-print-none" width="1">
                  <input :value="order.Order.Id" type="checkbox" v-model="checkedOrders">
                </td>
                <td class="text-nowrap" style="width: 100px;">
                  {{order.Order.RecastNumber > 0 ? 'Переделка заказа ' : ''}} {{order.Order.SferaNumber}} {{order.Order.LocalNumber && (`/
                  ${order.Order.LocalNumber}`)}}
                </td>
                <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">
                  {{order.Order.Name}}
                </td>
                <td class="text-right text-nowrap" v-for="paymentType in $root.paymentTypes">
                  {{order.Order.PaymentTypeId === paymentType.Id ? (order.Order.Summary ? order.Order.Summary : '') : ''}}
                </td>
                <td class="d-print-none" width="30">
                  <button @click.prevent="deleteDelivery([order.Delivery.Id])" class="btn btn-outline-secondary btn-sm" type="button">
                    <font-awesome-icon :icon="['far', 'trash-alt']"/>
                  </button>
                </td>
                <td class="d-print-none" width="50">
                  <div class="dropdown">
                    <button :class="statusColor(order.Order.OrderStatusId)"
                            aria-expanded="false"
                            aria-haspopup="true" class="btn dropdown-toggle btn-sm btn-block"
                            data-toggle="dropdown" id="dropdownMenuButton" type="button">
                      {{getStatusNameById(order.Order.OrderStatusId)}}
                    </button>
                    <div class="dropdown-menu">
                      <h6 class="dropdown-header">Изменить статус</h6>
                      <a @click.prevent="setStatus([order.Order.Id], status.Code)" class="dropdown-item" href="#" v-for="status in allowedStatuses">{{status.Name}}</a>
                      <h6 class="dropdown-header">Операции</h6>
                      <a @click.prevent="partPaid(order.Order.Id)" class="dropdown-item" href="#">Оплачен частично</a>
                    </div>
                  </div>
                </td>
                <td class="d-print-none" style="" width="170">
                  <div class="d-flex flex-row">
                    <date-picker :editable="false"
                                 :format="momentFormat"
                                 @input="setPaidDate([order.Order.Id], $event)"
                                 clearButton="false"
                                 input-class="form-control form-control-sm"
                                 lang="ru"
                                 :first-day-of-week="1"
                                 placeholder=""
                                 style="width: auto;"
                                 v-model="order.Order.PaidDate"
                                 valueType="format">
                    </date-picker>
                    <button @click.prevent="setDeliveryPaidDate([order.Order.Id])"
                            class="btn btn-sm btn-outline-info ml-2"
                            content="Назначить дату оплаты из доставки"
                            type="button"
                            v-tippy>
                      <font-awesome-icon :icon="['far', 'calendar-plus']"/>
                    </button>
                  </div>
                </td>
                <td class="d-print-none" style="" width="170">
                  <div class="d-flex flex-row">
                    <date-picker :editable="false"
                                 :format="momentFormat"
                                 @input="setPassedDate([order.Order.Id], $event)"
                                 clearButton="false"
                                 input-class="form-control form-control-sm"
                                 lang="ru"
                                 :first-day-of-week="1"
                                 placeholder=""
                                 style="width: auto;"
                                 v-model="order.Order.PassedDate"
                                 valueType="format">
                    </date-picker>
                    <button @click.prevent="setCurrentPassedDate([order.Order.Id])"
                            class="btn btn-sm btn-outline-info ml-2"
                            content="Назначить текущую дату получения"
                            type="button"
                            v-tippy>
                      <font-awesome-icon :icon="['far', 'calendar-check']"/>
                    </button>
                  </div>
                </td>
                <td class="d-none d-print-table-cell" width="100">
  <!--                <vue-barcode :margin="0" :value="order.Order.SferaNumber" display-value="false" height="20" width="2">-->
  <!--                  Ошибка штрихкода-->
  <!--                </vue-barcode>-->
                </td>
              </tr>
            </template>
          </template>
          </tbody>
          <tfoot class="font-weight-bold text-right" :set="orderTotals=ordersTotalAmount(receptionOrders)">
            <tr>
              <td class="d-print-none" colspan="3">Итого в приемном пункте</td>
              <td class="d-none d-print-table-cell" colspan="2">Итого в приемном пункте</td>
              <td v-for="PaymentType in $root.paymentTypes">
                {{orderTotals[PaymentType.Id] || 0}}
              </td>
              <td class="d-print-none" colspan="2"></td>
              <td class="d-none d-print-table-cell"></td>
              <td class="d-print-none">{{totalWithPaidDate}}</td>
              <td class="d-print-none">{{totalWithPassedDate}}</td>
            </tr>
            <tr class="d-none d-print-table-row">
              <td colspan="9" class="text-right">Подпись партнера: __________________________</td>
            </tr>
          </tfoot>
<!--          <tfoot class="font-weight-bold text-right">-->
<!--            <tr>-->
<!--              <td class="d-print-none" colspan="3">Итого в доставке</td>-->
<!--              <td class="d-none d-print-table-cell" colspan="2">Итого в доставке</td>-->
<!--              <td v-for="PaymentType in $root.paymentTypes">-->
<!--                {{totalAmount[PaymentType.Id] || 0}}-->
<!--              </td>-->
<!--              <td class="d-print-none" colspan="2"></td>-->
<!--              <td class="d-none d-print-table-cell"></td>-->
<!--              <td class="d-print-none">{{totalWithPaidDate}}</td>-->
<!--              <td class="d-print-none">{{totalWithPassedDate}}</td>-->
<!--            </tr>-->
<!--          </tfoot>-->
        </table>

<!--        <undelivered-orders-by-date-and-tour class="d-none d-print-block" :items="undeliveredOrdersByDateAndTour" v-if="isUndeliveredOrdersByDateAndTour"></undelivered-orders-by-date-and-tour>-->

      </div>
    </div>
    <div class="alert-info p-3 mb-3">
      <legend>Выбрано заказов: {{checkedOrders.length}}</legend>
      <div class="d-flex flex-row">
        <div>
          <div>
            <label class="">Выберите статус</label>
          </div>
          <div class="dropdown">
            <button aria-expanded="false"
                    aria-haspopup="true" class="btn btn-outline-info dropdown-toggle btn-sm btn-block"
                    data-toggle="dropdown" id="dropdownMenuButton" type="button">
              Выберите
            </button>
            <div class="dropdown-menu">
              <h6 class="dropdown-header">Изменить статус</h6>
              <a @click.prevent="setStatus(checkedOrders, status.Code)" class="dropdown-item" href="#" v-for="status in allowedStatuses">{{status.Name}}</a>
              <!--                <h6 class="dropdown-header">Операции</h6>-->
              <!--                <a class="dropdown-item" href="#">Оплачен частично</a>-->
            </div>
          </div>
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить дату оплаты</label>
          </div>
          <div>
            <date-picker :editable="false"
                         :format="momentFormat"
                         @input="setPaidDate(checkedOrders, $event)"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         v-model="allPaidDate"
                         valueType="format">
            </date-picker>
          </div>
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить дату получения</label>
          </div>
          <div>
            <date-picker :editable="false"
                         :format="momentFormat"
                         @input="setPassedDate(checkedOrders, $event)"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         v-model="allPassedDate"
                         valueType="format">
            </date-picker>
          </div>
        </div>

      </div>
    </div>
<!--    <form @submit.prevent="addOrder" class="mb-5" method="post">-->
<!--      <legend>Добавить заказ</legend>-->
<!--      <div class="form-group">-->
<!--        <div class="input-group">-->
<!--          <input class="form-control" placeholder="Номер сферы" ref="inputSferaNumber" required type="number" v-model="sferaNumber">-->
<!--          <div class="input-group-append">-->
<!--            <button class="btn btn-outline-secondary" type="submit">Проверить и добавить</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </form>-->
    <v-dialog/>
    <modals-container/>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import DatePicker from 'vue2-datepicker';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery.vue';
import ReceptionHeadTr from '@/admin/modules/Delivery/_components/ReceptionHeadTr.vue';
import OrderTr from '@/admin/modules/Delivery/_components/OrderTr.vue';
import { get, post, put } from '@/admin/services/api/http-utils';
import AirDatepicker from '@/admin/components/AirDatepicker.vue';
import PartPaid from '@/admin/components/modals/PartPaid.vue';
import UndeliveredOrdersByDateAndTour from '@/admin/modules/Delivery/_components/UndeliveredOrdersByDateAndTour.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
const type = 'partner';

export default {
  components: {
    DatePicker,
    PartnerDelivery,
    VueBarcode,
    ReceptionHeadTr,
    OrderTr,
    AirDatepicker,
    UndeliveredOrdersByDateAndTour,
  },
  props: {
    time: String,
    panelUserId: [String, Number],
    customerId: [String, Number],
    allowPrinting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      undeliveredOrdersByDateAndTour: [],
      orderList: [],
      orderListGroupByPoint: [],
      statuses: [],
      sferaNumber: '',
      courier: {},
      summaries: [],
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
      checkAll: false,
      checkedOrders: [],
      allPassedDate: null,
      allPaidDate: null,
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      pointDebt: [],
    };
  },
  // async created() {
  //
  //   // this.fetchCourier();
  //   // this.calcAll();
  // },
  async mounted() {
    this.fetchCourier();
    await this.fetchDebtByTourId();
    await this.fetchStatuses();
    await this.fetchUndeliveredOrdersByDateAndTour();
  },
  watch: {
    orderList() {
      if (this.orderList) {
        let arr = _.groupBy(this.orderList, 'Point.Id');
        arr = _.sortBy(arr, x => _.head(x).Tour.Name);
        // arr = _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        arr = arr.sort((a, b) => _.head(a).Point.Reception.localeCompare(_.head(b).Point.Reception));// _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        // arr = _.map(arr, x => _.orderBy(x, ['Point.Reception'], ['desc']));
        this.orderListGroupByPoint = arr;
      } else {
        this.orderListGroupByPoint = [];
      }
    },
    checkAll(newVal) {
      console.log(newVal);
      if (newVal) {
        this.checkedOrders = _.map(this.orderList, o => o.Order.Id);
      } else {
        this.checkedOrders = [];
      }
    },
    // orders() {
    //   this.calcAll();
    // },
  },
  computed: {
    totalAmount() {
      const totalAmount = {};
      _.each(this.$root.paymentTypes, (val) => {
        totalAmount[val.Id] = _.sumBy(this.orderList, (o) => {
          if (o.Order.PaymentTypeId === val.Id) {
            return o.Order.Summary;
          }
        });
      });
      return totalAmount;
    },
    totalWithPassedDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PassedDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    totalWithPaidDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PaidDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    allowedStatuses() {
      return _.filter(this.statuses, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
    allChecked() {
      return this.orderList.length === this.checkedOrders.length;
    },
    // customerOrders() {
    //   return _.groupBy(this.orders, order => order.order.CustomerId);
    // },
    courierBarCode() {
      return `cd_${this.$route.query.panelUserId}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    currentDate() {
      return moment()
        .format('DD-MM-YYYY, h:mm:ss');
    },
    existTourIds() {
      if (!this.orderList) {
        return [];
      }

      return _.uniq(_.map(this.orderList, 'Tour.Id'));
    },
    isUndeliveredOrdersByDateAndTour() {
      if (!this.undeliveredOrdersByDateAndTour) {
        return false;
      }
      return _.values(this.undeliveredOrdersByDateAndTour).length;
    },
  },
  methods: {
    ordersTotalAmount(orders) {
      const totalAmount = {};
      _.each(this.$root.paymentTypes, (val) => {
        totalAmount[val.Id] = _.sumBy(orders, (o) => {
          if (o.Order.PaymentTypeId === val.Id) {
            return o.Order.Summary;
          }
        });
      });
      return totalAmount;
    },
    getReceptionSummary(reception) {
      return _.sumBy(reception, 'Order.Summary');
    },
    async setPassedDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-passed-date`, { orderItemIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchUndeliveredOrdersByDateAndTour() {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/delivery/undelivered-orders-date-tour/${this.$props.time}/${this.existTourIds.join(',')}`);
      this.undeliveredOrdersByDateAndTour = data;
    },
    async deleteDelivery(DeliveryIds) {
      // if (!confirm('Подтвердите действие')) return;
      console.log(DeliveryIds);
      // return;
      await post(`${process.env.VUE_APP_API_HOST}admin/delivery/delete`, { DeliveryIds });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setCurrentPassedDate(orderItemIds) {
      this.setPassedDate(orderItemIds, (new Date()).getTime() / 1000);
    },

    async setPaidDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await put(`${process.env.VUE_APP_API_HOST}admin/order/set-paid-date`, { orderItemIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setDeliveryPaidDate(orderItemIds) {
      const deliveryDate = _.head(this.orderList).Delivery.DeliveryDate;
      this.setPaidDate(orderItemIds, deliveryDate);
    },

    async setStatus(orderItemIds, statusCode) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-status`, { orderItemIds, statusCode });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchStatuses() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.statuses = data.data;// _.filter(data.data, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },

    partPaid(orderItemId) {
      const that = this;
      this.$modal.show(PartPaid, {
        orderItemId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      }, {
        'before-close': function () {
          that.fetchDebtByTourId();
        },
      });
    },

    async fetchDebtByTourId() {
      const query = Object.assign({}, this.$props, { paymentTypes: ['НС'] });
      const { data } = await get(`${url}/by-time-and-panel-user/${type}`, query);
      this.orderList = data;
      this.fetchPointDebt();
    },
    async fetchPointDebt() {
      const pointIds = _.map(this.orderList, o => o.Point.Id);
      const { data } = await get(`${url}/point-debt/${pointIds.join(',')}`);
      this.pointDebt = data;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    print2() {
      this.$htmlToPaper('printMe2');
    },
    async fetchCourier() {
      const { data } = await get(`${url}/couriers/${this.$route.query.panelUserId}`);
      this.courier = data;
    },
    checkByPointId(event, PointId) {
      const value = event.target.checked;
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      // console.log('orderIds', orderIds);
      let merged = [];
      if (value) {
        merged.push(...this.checkedOrders);
        merged.push(...orderIds);
        merged = _.uniq(merged);
        this.checkedOrders = merged;
      } else {
        this.checkedOrders = _.filter(this.checkedOrders, id => !_.includes(orderIds, id));
      }

      // console.log(event.target.checked, PointId);
    },
    fullFilledPoint(PointId) {
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      return !_.difference(orderIds, this.checkedOrders).length;
    },
    getStatusNameById(statusId) {
      // console.log(this.statuses, statusId)
      const status = _.find(this.statuses, o => o.Id === statusId);
      // console.log(status)
      return status ? status.Name : '';
      // return status.Name;
    },
    statusColor(statusId) {
      const status = _.find(this.statuses, o => o.Id === statusId);
      if (status && status.Code === 'in_dispatch') {
        return 'btn-danger';
      }
      if (status && status.Code === 'delivered') {
        return 'btn-success';
      }
      return 'btn-outline-info';
    },
    pointBarCode(Point) {
      return `pd_${Point.Id}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    // async addOrder() {
    //   try {
    //     const { data } = await get(`${url}/is-in-delivery/${this.sferaNumber}`);
    //     const appendOrder = async () => {
    //       await post(`${url}/append-order-to-delivery/${this.sferaNumber}`, {
    //         DeliveryDate: this.$route.query.time,
    //         PanelUserId: this.$route.query.panelUserId,
    //       });
    //       this.fetchDelivery();
    //       this.$modal.hide('dialog');
    //     };
    //     if (data) {
    //       this.$modal.show('dialog', {
    //         title: 'Предупреждение',
    //         text: `Заказ ${this.sferaNumber} уже есть в доставке на ${moment(String(data.DeliveryDate))
    //           .format('DD-MM-YYYY hh:mm')}`,
    //         buttons: [
    //           {
    //             title: 'Переназначить текущему пользователю', // Button title
    //             default: true, // Will be triggered by default if 'Enter' pressed.
    //             handler: appendOrder, // Button click handler
    //           },
    //           {
    //             title: 'Закрыть',
    //           },
    //         ],
    //       });
    //     } else {
    //       appendOrder();
    //     }
    //   } catch (error) {
    //     if (error.response && error.response.data) {
    //       this.$toasted.show(error.response.data, { type: 'error' });
    //     } else {
    //       this.$toasted.show('Неизвестная ошибка', { type: 'error' });
    //     }
    //   }
    // },
    // getDeliveryIDs() {
    //   return _.map(this.orders, item => item.delivery.Id);
    // },
    // allToDelivered() {
    //   this.markDeliveries('IsDelivered', this.getDeliveryIDs(), this.allIsDelivered);
    // },
    // allToPaid() {
    //   this.markDeliveries('IsPaid', this.getDeliveryIDs(), this.allIsPaid);
    // },
    // allToPassed() {
    //   this.markDeliveries('IsPassed', this.getDeliveryIDs(), this.allIsPassed);
    // },
    // markDeliveries(PropName, DeliveryIDs, value) {
    //   let titlePropName;
    //   switch (PropName) {
    //     case 'IsDelivered':
    //       titlePropName = 'Доставлены';
    //       break;
    //     case 'IsPaid':
    //       titlePropName = 'Оплачены';
    //       break;
    //     case 'IsPartPaid':
    //       titlePropName = 'Частично оплачены';
    //       break;
    //     case 'IsPassed':
    //       titlePropName = 'Сданы';
    //       break;
    //     default:
    //       titlePropName = null;
    //   }
    //   const mark = async () => {
    //     console.log(!value);
    //     await post(`${url}/mark-deliveries`, {
    //       PropName,
    //       DeliveryIDs,
    //       value: !value,
    //     });
    //     this.fetchDelivery();
    //     this.$modal.hide('dialog');
    //   };
    //   this.$modal.show('dialog', {
    //     title: 'Предупреждение',
    //     text: `Пометить доставки ${titlePropName ? `"${titlePropName}"` : ''}?`,
    //     buttons: [
    //       {
    //         title: 'Да', // Button title
    //         default: true, // Will be triggered by default if 'Enter' pressed.
    //         handler: mark,
    //       },
    //       {
    //         title: 'Отмена',
    //       },
    //     ],
    //   });
    // },
    // async commitPartAmount(data) {
    //   const { DeliveryId, PartAmount } = data;
    //   await put(url, { Id: DeliveryId, PartAmount });
    //   this.fetchDelivery();
    // },
  },
};
</script>
<style lang="scss">
.table-cell-align-middle {
  tr {
    td {
      vertical-align: middle;
    }
  }
}
@media print {
  .pagebreak {
    clear: both;
    page-break-before: always;
  } /* page-break-after works, as well */
}
</style>
